<template>
  <div class="feedbacks-filters">
    <a
      v-for="button in buttons"
      :key="button.type"
      :class="['feedbacks-filter', `feedback-${button.type}`, { 'feedbacks-filter-none': !filter[button.type] }]"
      @click="onClick(button.type)"
    >
      <div />
      <span>{{button.count}}</span>
    </a>
  </div>
</template>

<script>
import { FEEDBACK_TYPE } from '@/helpers/types'

export default {
  name: 'FeedbacksFilter',

  model: {
    prop: 'filter',
    event: 'change'
  },

  props: {
    filter: {
      type: Object,
      default: () => ({})
    },

    feedbacks: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    counts() {
      return this.feedbacks.reduce((out, value) => {
        if (!out[value.type]) {
          out[value.type] = 1
        } else {
          out[value.type]++
        }
        return out
      }, {})
    },

    buttons() {
      return Object.values(FEEDBACK_TYPE)
        .filter(type => Boolean(this.counts[type]))
        .map(type => ({ type, count: this.counts[type] }))
    }
  },

  methods: {
    onClick(type) {
      this.$emit('change', { ...this.filter, [type]: !this.filter[type] })
    }
  }
}
</script>
